// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"be2a4f3a","63":"637fdbc8","305":"5362eba2","787":"7da95b79","835":"4359b4fe","892":"5b5c6010","933":"61ddd577"}[chunkId] + ".chunk.js";
};